import React from 'react';
import { Table } from '../../dashboard/types';

interface TableMapProps {
  onPickPosition: (x: number, y: number) => void;
    selectedPosition?: { x: number; y: number };
    tables: Table[];
}

export const TableMap: React.FC<TableMapProps> = ({
  onPickPosition,
    selectedPosition,
  tables
}) => {
    const adjustPosition = (x: number, y: number) => {
        // Ensure the position is within bounds (0-100%)
        const adjustedX = x < 0 ? 10 : x < 30 ? 10 : x < 50 ? 30 : x < 70 ? 50 : x < 90 ? 70 : 90;
        const adjustedY = y < 0 ? 15 : y < 45 ? 15 : y < 75 ? 45 : 75;
        return { x: adjustedX, y: adjustedY };
    };
  const handleMapClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width * 100;
    const y = (e.clientY - rect.top) / rect.height * 100;
    const adjustedPosition = adjustPosition(x, y);
    onPickPosition(adjustedPosition.x, adjustedPosition.y);
  };

  return (
    <div className='mx-auto'
      style={{
        width: '100%',
        height: '500px',
        background: '#f0f0f0',
        border: '2px solid #ccc',
        position: 'relative',
        cursor: 'crosshair',
      }}
      onClick={handleMapClick}
      data-testid='table-map'>
      {selectedPosition && (
        <div
          style={{
            position: 'absolute',
            left: `${selectedPosition.x}%`,
            top: `${selectedPosition.y}%`,
            width: '12vw',
            minWidth: 44,
            maxWidth: 80,
            height: '12vw',
            minHeight: 44,
            maxHeight: 80,
            background: 'rgba(0, 123, 255, 0.7)',
            // borderRadius: '50%',
            border: '2px solid #007bff',
            pointerEvents: 'none',
          }}
        ></div>
      )}
      {tables.map((table) => (
        <div className='flex justify-center text-center items-center hover:scale-105 transition-transform'
          key={table.id}
          style={{
            position: 'absolute',
            left: `${table.position?.x ?? 0}%`,
            top: `${table.position?.y ?? 0}%`,
            width: '12vw',
            minWidth: 44,
            maxWidth: 80,
            height: '12vw',
            minHeight: 44,
            maxHeight: 80,
            background: table.isVip
              ? 'rgba(255, 215, 0, 0.7)'
              : 'rgba(0, 123, 255, 0.7)',
            // borderRadius: '50%',
            border: table.isVip ? '2px solid #FFD700' : '2px solid #007bff',
            pointerEvents: 'none',
          }}
        >{table.tableNumber}</div>
      ))}
    </div>
  );
};
